export default __webpack_public_path__ + "static/media/pin.ecfd58de.svg";